import React, {Component} from 'react'
import {weatherData} from './weatherData';
import WeatherList from './WeatherList';
import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';

class WeatherDetail extends Component {


    constructor() {
        super();

        this.state = {
            city: '',
            list: '',
            bgColorClass: ''
        }

        this.loadWeatherData();
    }

    async loadWeatherData() {
        let data = await weatherData;
        this.setState(data);
        const colorClass = this.getBgColourClass(data.list)
        this.setState({bgColorClass: colorClass});
    }

    getBgColourClass(list) {
        let bgColorClass = 'detail-weather-widget ';
        // Set the background colour based on the temperature
        if (list[0].main.temp.toFixed(1) >= 30) {
            bgColorClass += 'very-warm';
        } else if (list[0].main.temp.toFixed(1) > 20 && list[0].main.temp.toFixed(1) < 30) {
            bgColorClass += 'warm';
        } else if (list[0].main.temp.toFixed(1) > 10 && list[0].main.temp.toFixed(1) < 20) {
            bgColorClass += 'normal';
        } else if (list[0].main.temp.toFixed(1) > 0 && list[0].main.temp.toFixed(1) < 10) {
            bgColorClass += 'cold';
        } else if (list[0].main.temp.toFixed(1) <= 0) {
            bgColorClass += 'very-cold';
        }

        return bgColorClass;
    }


    render() {
        const {city, list, bgColorClass} = this.state;


        // TODO: Use loading
        if (!this.state.city) {
            return <div>در حال بارگزاری</div>
        }


        return (
            <div className={bgColorClass}>
                <div className="row">
                    <div className="col-12">
                        <div className="jr-card-header">
                            <div className="py-sm-2">
                                <h3 className="card-heading">وضعیت آب و هوایی</h3>
                            </div>
                            <div className="mr-auto">
                                <h2 className="card-heading">{city.name}</h2>
                                <p className="sub-heading">{city.dateTime}</p>
                            </div>
                        </div>
                        <div className="temp-section py-sm-2 d-flex justify-content-between align-items-center">
                            <h2 className="temp-point text-muted">{list[0].main.temp.toFixed(1)}
                                <small><sup>°C</sup></small>
                            </h2>
                            <div className="px-md-4">
                                <i className={"detail-icon text-blue-grey wi wi-owm-" + list[0].weather[0].id}/>
                            </div>
                        </div>
                    </div>
                </div>
                <hr/>
                <WeatherList weather={list.slice(1, list.length)}/>
                {/*<Button variant="raised" className="jr-btn bg-primary text-uppercase text-white">full report</Button>*/}
            </div>
        )
    }
}

export default WeatherDetail;



// WEBPACK FOOTER //
// ./components/Weather/WeatherDetail.js